<template lang="html">

  <b-container fluid>

    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
            <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%" @click="navigateToHomePage" />
            <b-card v-if="!success" title="Reset Password"  sub-title="" style=" margin-top:3%">
                <form role="form" v-on:submit.prevent="reset()"  v-if="!busy">
                    <fieldset>
                        <div class="form-group">
                            <input v-model="form.userName" aria-describedby="usernameInput"  class="form-control" placeholder="Username" name="username" type="text">
                            <b-form-invalid-feedback id="usernameInput">
                                Value is Required
                            </b-form-invalid-feedback>
                        </div>
                        <!-- Change this to a button or input when using this as a form -->
                        <button type="submit" class="btn btn-lg btn-blade btn-block" :show="canSendReset" :disabled="success">Send reset request</button>
                        <br/>
                        <!-- <b-link :to="'/'" v-if="!success">Home</b-link> -->
                    </fieldset>
                </form>
                <div class="loader"> <stretch v-if="busy" ></stretch> </div>
            </b-card>
        </b-col>
    </b-row>
    <b-row>
      <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
          <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">  {{errorMsg}}
            <!-- <b-button variant="danger" size="sm"  v-on:click="update">
                  Retry
            </b-button> -->
          </b-alert>
             <b-alert :show="busy" variant="info" @dismissed="busy=false">
              Sending password reset verification code to e-mail address on file.
             </b-alert>
             <b-alert :show="success" variant="success" @dismissed="hasError=false">
              Your password reset verification code has been sent to the email address you provided when you registered. Please click the button below and enter the code on the next screen.
              <br/>
              <!-- <br/>
             <b-link style="font-weight:bold;" :to="'change'">Update Password</b-link>
             <br/> -->
          </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap v-if="success">
          <button v-on:click="navigateToUpdatePasswordPage" class="btn btn-lg btn-blade btn-block">Update Password</button>
      </b-col>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
</b-container>
</template>

<script lang="js">
import { Stretch } from 'vue-loading-spinner'
import LicenseFooter from './LicenseFooter'
import { USER_NOT_FOUND_EXCEPTION, USER_NOT_FOUND_CHPASS_EXCEPTION_MSG } from '../../src/constants'

export default {
  name: 'request-reset',
  components: { Stretch, LicenseFooter },
  props: [],
  mounted () {
  },
  computed: {
    canSendReset () {
      return !this.busy && !this.success
    }
  },
  data () {
    return {
      form: {
        userName: ''
      },
      hasError: false,
      errorMsg: '',
      busy: false,
      success: false
    }
  },
  methods: {
    navigateToHomePage() {
      this.$router.push('/')
    },

    navigateToUpdatePasswordPage() {
      this.$router.push('/change')
    },

    async reset () {
      let self = this
      try {
        self.success = false
        self.hasError = false
        self.busy = true
        let response = await self.$auth.resetPassword(self.form.userName)
        if (response.status === 200) {
          self.busy = false
          self.success = true
        }
      } catch (error) {
        self.hasError = true
        self.busy = false
        if (error.response && error.response.data === USER_NOT_FOUND_EXCEPTION) {
          self.errorMsg = USER_NOT_FOUND_CHPASS_EXCEPTION_MSG
        } else {
          self.errorMsg = 'An error occurred. Please contact your user administrator.'
        }
      }
    }
  }
}
</script>
<style src="../assets/styles.css">

</style>
<style scoped lang="scss">
  .request-reset {

  }
</style>



// WEBPACK FOOTER //
// src/components/RequestReset.vue